import React from 'react';
import {
  Flex,
  IconButton,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  HStack,
  Skeleton,
} from '@chakra-ui/react';
import { MdMoreVert } from 'react-icons/md';
import { PermissionsRequiredWarning, SyncingInstallationAlert, ExternalLink } from '#components';
import { t } from '#i18n';

export const InstallationCell = ({
  installation = null,
  isSelected = false,
  refetchInstallation = null,
  onClick = () => {},
  ...props
}) => {
  const { profile, status, manageUrl } = installation || {};

  const loading = !installation;
  const isSyncing = !loading && status === 'SYNCING';
  const requiresPermissions = !loading && status !== 'ACTIVE' && status !== 'SYNCING';

  return (
    <Flex
      backgroundColor={isSelected ? 'primary.300' : 'transparent'}
      flexDirection="column"
      paddingX={4}
      paddingY={4}
      _hover={{ backgroundColor: 'primary.300', cursor: 'pointer' }}
      {...props}
    >
      <Flex
        alignItems="center"
        justifyContent="space-between"
        onClick={() => onClick(installation)}
      >
        <HStack>
          <Skeleton
            isLoaded={!loading}
            borderRadius="md"
            aria-hidden={!loading}
            data-testid={props['data-testid'] ? `${props['data-testid']}.LoadingImage` : null}
          >
            <Image
              alt={profile?.name}
              src={profile?.avatarUrl}
              boxSize={8}
              borderRadius="md"
            />
          </Skeleton>
          <Skeleton
            isLoaded={!loading}
            height={loading ? 4 : null}
            width={loading ? 32 : null}
            aria-hidden={!loading}
            data-testid={props['data-testid'] ? `${props['data-testid']}.LoadingName` : null}
          >
            <ExternalLink href={profile?.url} target="_blank">
              <Text>{profile?.name}</Text>
            </ExternalLink>
          </Skeleton>
        </HStack>
        {!requiresPermissions && <ShowMoreMenu isDisabled={loading} installation={installation} />}
      </Flex>
      {requiresPermissions && (
        <PermissionsRequiredWarning
          variant="subtle"
          marginTop={4}
          permissionsGrantUrl={manageUrl}
          message={t('alerts.permissionsRequired.message')}
        />
      )}
      {isSyncing && (
        <SyncingInstallationAlert
          variant="subtle"
          marginTop={4}
          installation={installation}
          refetchInstallation={refetchInstallation}
        />
      )}
    </Flex>
  );
};

const ShowMoreMenu = ({ installation, isDisabled = false }) => (
  <Menu disabled>
    <MenuButton
      as={IconButton}
      isDisabled={isDisabled}
      aria-label={t('settings.manageOrganizations.showMore')}
      icon={<MdMoreVert />}
      variant="ghost"
      onClick={(e) => e.stopPropagation()}
    />
    <MenuList>
      <MenuItem onClick={() => window.open(installation.manageUrl, '_blank')}>
        {t('settings.manageOrganizations.manage')}
      </MenuItem>
    </MenuList>
  </Menu>
);
